import React from 'react';
import { Button } from '../../../components/ui/button';
import { Shield, LogOut } from 'lucide-react';

function SuperAdminHeader({ onLogout }) {
    return (
        <header className="bg-gray-800 border-b border-border px-6 py-4">
            <div className="max-w-7xl mx-auto flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <Shield className="w-8 h-8 text-primary" />
                    <div>
                        <h1 className="text-xl font-bold">Homly Super Admin</h1>
                        <p className="text-sm text-muted-foreground">Panel de gestion service client</p>
                    </div>
                </div>
                <Button
                    variant="outline"
                    onClick={onLogout}
                    className="border-gray-600 text-foreground hover:bg-gray-700"
                    data-testid="superadmin-logout"
                >
                    <LogOut className="w-4 h-4 mr-2" />
                    Déconnexion
                </Button>
            </div>
        </header>
    );
}

export default SuperAdminHeader;
